// Crew — Button (Agent B). Coral primary / sand secondary / ghost. ≥44px tap target.
import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  busy?: boolean;
  children: ReactNode;
}

const BASE =
  'inline-flex min-h-[44px] items-center justify-center gap-2 rounded-xl2 px-5 text-sm font-semibold ' +
  'transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ' +
  'focus-visible:ring-coral-500 focus-visible:ring-offset-sand-50 disabled:cursor-not-allowed disabled:opacity-50';

const VARIANTS: Record<Variant, string> = {
  primary: 'bg-coral-500 text-white hover:bg-coral-600 active:bg-coral-600',
  secondary: 'bg-sand-100 text-ink-800 ring-1 ring-sand-200 hover:bg-sand-200',
  ghost: 'bg-transparent text-ink-700 hover:bg-sand-100',
  danger: 'bg-white text-coral-600 ring-1 ring-coral-400 hover:bg-coral-400/10',
};

export function Button({ variant = 'primary', busy = false, disabled, children, className = '', ...rest }: ButtonProps) {
  return (
    <button
      {...rest}
      disabled={disabled || busy}
      aria-busy={busy || undefined}
      className={`${BASE} ${VARIANTS[variant]} ${className}`}
    >
      {busy && (
        <span
          aria-hidden
          className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent"
        />
      )}
      {children}
    </button>
  );
}
